
import { Vue, Component, Prop } from 'vue-property-decorator';
import { Action, Getter } from 'vuex-class';
import 'vue-select/dist/vue-select.css';

const namespace: string = 'restaurant';

@Component<RestaurantIndex>({})
export default class RestaurantIndex extends Vue {
	@Prop({ type: String, required: true, default: '' }) private restaurantSlug!: string;
	@Action('fetchRestaurant', { namespace }) private fetchRestaurant!: (payload: FetchRestaurantPayload) => Promise<boolean>;
	@Getter('getRestaurant', { namespace }) private restaurant!: Restaurant;
	@Getter('hasCssLoaded', { namespace: 'restaurant' }) private cssLoaded!: boolean;
	@Getter('getUser', { namespace: 'auth' }) private user!: UserInfo;
	@Getter('isAuthenticated', { namespace: 'auth' }) private isAuthenticated!: boolean;

	private dataFetched: boolean = false;

	private async created(): Promise<void> {
		if(!this.restaurant || !this.restaurant.name) {
			try {
				await this.fetchRestaurant({
					restaurantSlug: this.restaurantSlug,
					route: this.$route,
					router: this.$router
				});
			}
			catch (error) {
				if (error.errorMessage) {
					this.$toasted.show(error.errorMessage, { type: 'error', position: 'top-center' }).goAway(5000);
				}
				else {
					this.$router.push({ name: 'PageNotFound' }).catch(() => {});
				}
			}
			finally {
				this.dataFetched = true;
			}
		}
		// Already fetched the data needed
		else {
			this.dataFetched = true;
		}
	}
}
